import { LocationOn } from "@mui/icons-material";
import {
  Box,
  Typography,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import { useQuery } from "react-query";
import CustomInput from "../../FormFields/CustomInput/CustomInput";
import DynamicSelectInput from "../../FormFields/CustomSelect/DynamicSelectInput";
import { QK } from "../../../base/qk";
import { getAreas } from "../../../api/services/location";

const IncidentDetails = ({ formData, handleFormChange }) => {
  const theme = useTheme();
  const { data: areas, isLoading } = useQuery([QK.areas], () => getAreas());

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LocationOn
            sx={{ fontSize: 20, color: theme.palette.primary.main }}
          />
        </Box>
        <Box>
          <Typography
            variant="h6"
            fontWeight={700}
            color="#1A1A2E"
            fontSize="0.95rem"
          >
            Location & Description
          </Typography>
          <Typography variant="caption" color="#6B7280" fontSize="0.7rem">
            Where and how the incident happened
          </Typography>
        </Box>
      </Box>

      <DynamicSelectInput
        name="area"
        label={isLoading ? "Loading areas..." : "Where did it happen?"}
        selectedValue={formData?.area}
        onChange={handleFormChange}
        options={areas}
        required
        initialLabel={false}
      />

      <Stack spacing={2}>
        <CustomInput
          name="what_happened_before"
          label="What happened before incident?"
          value={formData?.what_happened_before}
          onChange={handleFormChange}
          multiline
          rows={2}
          placeholder="Describe what happened before the incident..."
        />

        <CustomInput
          name="incident_description"
          label="Description of the incident?"
          value={formData?.incident_description}
          onChange={handleFormChange}
          multiline
          rows={2}
          placeholder="Provide detailed description of the incident..."
        />

        <CustomInput
          name="action_taken"
          label="What immediate actions were taken?"
          value={formData?.action_taken}
          onChange={handleFormChange}
          multiline
          rows={2}
          placeholder="Describe the immediate actions taken after the incident..."
        />
      </Stack>
    </Box>
  );
};

export default IncidentDetails;